import * as React from "react";
const SvgTriangleUpLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.541 7.594a2 2 0 0 1 2.827-.09c.047.044.047.044.091.09l5.192 5.538a2 2 0 0 1-1.459 3.368H6.809a2 2 0 0 1-1.46-3.368zm1.46 1.368L6.808 14.5h10.383z", clipRule: "evenodd" }));
export default SvgTriangleUpLine;
